import { mapDTO } from '@twistezo/ts-dto-mapper'

import { AdUnitSizeDTO } from 'features/globalSetup/features/viewport'
import { adUnitSizeToDTO } from 'features/globalSetup/features/viewport/utils'
import { floatPercentToDTO, secondsToMilliseconds } from 'utils/number'
import { Schema } from '../../schema'
import { Variables } from './types'

type From = Schema

type To = Variables

export const toDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform((from: From): To => {
    const { id, refresherEnabled, refreshRedirect } = from
    const { additionalSizes, sendRefreshRequestToExternalAdUnitEnabled, targetAdUnitPath } =
      refreshRedirect

    const {
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold,
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval,
      mobileAdThreshold,
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval,
    } = from.basicSettings

    return {
      adUnitId: id,
      customizeRefresherBasicSettingsEnabled,
      desktopAdThreshold: floatPercentToDTO(desktopAdThreshold),
      desktopMonitorUserScrollEnabled,
      desktopRefreshInterval: secondsToMilliseconds(desktopRefreshInterval),
      mobileAdThreshold: floatPercentToDTO(mobileAdThreshold),
      mobileMonitorUserScrollEnabled,
      mobileRefreshInterval: secondsToMilliseconds(mobileRefreshInterval),
      refresherEnabled,
      sendRefreshRequestToExternalAdUnitEnabled,
      sizes: additionalSizes.map((size: string): AdUnitSizeDTO => adUnitSizeToDTO(size)),
      ...(sendRefreshRequestToExternalAdUnitEnabled
        ? { externalAdUnitPath: targetAdUnitPath }
        : {}),
    }
  })
